/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Offerhover_Igdbscore2Inputs */

const id_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor IGDB`)
};

const ms_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor IGDB`)
};

const da_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Score`)
};

const de_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-Punktzahl`)
};

const en_us2_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Score`)
};

const es_es2_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación IGDB`)
};

const es_mx2_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación IGDB`)
};

const fil_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Score`)
};

const fr_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score IGDB`)
};

const it_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio IGDB`)
};

const hu_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB pontszám`)
};

const nl_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-score`)
};

const no_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-poengsum`)
};

const pl_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik IGDB`)
};

const pt_br2_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação IGDB`)
};

const pt_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação IGDB`)
};

const ro_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scor IGDB`)
};

const fi_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-pisteet`)
};

const sv_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-poäng`)
};

const vi_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm IGDB`)
};

const tr_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Puanı`)
};

const cs_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skóre IGDB`)
};

const bg_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB резултат`)
};

const ru_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка IGDB`)
};

const uk_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оцінка IGDB`)
};

const ar_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتيجة IGDB`)
};

const hi_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB स्कोर`)
};

const th_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนน IGDB`)
};

const ja_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB スコア`)
};

const zh_cn2_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB评分`)
};

const zh_hant1_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB評分`)
};

const ko_home_offerhover_igdbscore2 = /** @type {(inputs: Home_Offerhover_Igdbscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB 점수`)
};

/**
* | output |
* | --- |
* | "IGDB Score" |
*
* @param {Home_Offerhover_Igdbscore2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_igdbscore2 = /** @type {((inputs?: Home_Offerhover_Igdbscore2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Igdbscore2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_igdbscore2(inputs)
	if (locale === "ms") return ms_home_offerhover_igdbscore2(inputs)
	if (locale === "da") return da_home_offerhover_igdbscore2(inputs)
	if (locale === "de") return de_home_offerhover_igdbscore2(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_igdbscore2(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_igdbscore2(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_igdbscore2(inputs)
	if (locale === "fil") return fil_home_offerhover_igdbscore2(inputs)
	if (locale === "fr") return fr_home_offerhover_igdbscore2(inputs)
	if (locale === "it") return it_home_offerhover_igdbscore2(inputs)
	if (locale === "hu") return hu_home_offerhover_igdbscore2(inputs)
	if (locale === "nl") return nl_home_offerhover_igdbscore2(inputs)
	if (locale === "no") return no_home_offerhover_igdbscore2(inputs)
	if (locale === "pl") return pl_home_offerhover_igdbscore2(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_igdbscore2(inputs)
	if (locale === "pt") return pt_home_offerhover_igdbscore2(inputs)
	if (locale === "ro") return ro_home_offerhover_igdbscore2(inputs)
	if (locale === "fi") return fi_home_offerhover_igdbscore2(inputs)
	if (locale === "sv") return sv_home_offerhover_igdbscore2(inputs)
	if (locale === "vi") return vi_home_offerhover_igdbscore2(inputs)
	if (locale === "tr") return tr_home_offerhover_igdbscore2(inputs)
	if (locale === "cs") return cs_home_offerhover_igdbscore2(inputs)
	if (locale === "bg") return bg_home_offerhover_igdbscore2(inputs)
	if (locale === "ru") return ru_home_offerhover_igdbscore2(inputs)
	if (locale === "uk") return uk_home_offerhover_igdbscore2(inputs)
	if (locale === "ar") return ar_home_offerhover_igdbscore2(inputs)
	if (locale === "hi") return hi_home_offerhover_igdbscore2(inputs)
	if (locale === "th") return th_home_offerhover_igdbscore2(inputs)
	if (locale === "ja") return ja_home_offerhover_igdbscore2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_igdbscore2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_igdbscore2(inputs)
	return ko_home_offerhover_igdbscore2(inputs)
});
export { home_offerhover_igdbscore2 as "home.offerHover.igdbScore" }